"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("@material-ui/core/styles");
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {
      borderRadius: '10px',
      backgroundColor: '#F7F7F7',
      padding: '16px 24px 24px 16px'
    },
    currentVersion: {
      color: '#212529',
      fontSize: '16px',
      fontWeight: 600
    },
    update: {
      fontWeight: 400,
      fontSize: '13px',
      color: '#212529'
    },
    title: {
      color: '#212529',
      fontWeight: 300,
      fontSize: '13px'
    },
    subTitle: {
      color: '#949494',
      fontWeight: 400,
      fontSize: '10px'
    },
    subContent: {
      color: '#949494',
      fontWeight: 300,
      fontSize: '10px'
    },
    icon: {
      marginRight: '10px',
      height: '16px'
    }
  };
}, {
  name: 'FileDownloadItem'
});
exports.useStyles = useStyles;